import request from "../libs/request";

const baseUrl = "etc/banner";

export type LinkLocationType =
  | "MAINROLL"
  | "MAINFIX"
  | "BUILDING"
  | "TALK"
  | "MYINFO";

export type GetBannerRequest = {
  location: LinkLocationType;
  buildingId?: string;
};

export type GetBannerResponse = {
  items: BannerItem[];
};

export type LinkType = "CURRENT" | "NULL" | "NEW";
export type BannerType = "NORMAL" | "ADVERTISEMENT";

export type BannerItem = {
  linkType: LinkType;
  linkUrl: string;
  file: string;
  type: BannerType;
  tagId: string | null;
};

export const getBanner = (params: GetBannerRequest) =>
  request.get<GetBannerResponse>(`${baseUrl}/${params.location}`, {
    params: { buildingId: params.buildingId },
  });
